module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/screens/kanban_board-6de0ee82f6653096c923edb39d011c0e.svg";